import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";

const KEY = "pl_cookie_consent";
export const getCookieConsent = () => localStorage.getItem(KEY);
export const reopenCookieBanner = () => {
  localStorage.removeItem(KEY);
  window.dispatchEvent(new Event("pl-cookie-reopen"));
};

export default function CookieBanner() {
  const [open, setOpen] = useState(() => !getCookieConsent());
  useEffect(() => {
    const h = () => setOpen(true);
    window.addEventListener("pl-cookie-reopen", h);
    return () => window.removeEventListener("pl-cookie-reopen", h);
  }, []);
  if (!open) return null;
  const choose = (v) => { localStorage.setItem(KEY, v); setOpen(false); };

  return (
    <div role="dialog" aria-label="Choix des cookies" data-testid="cookie-banner"
      className="fixed inset-x-3 bottom-3 z-50 mx-auto max-w-3xl rounded-3xl border-2 border-[color:var(--espresso)] bg-white p-5 shadow-2xl sm:inset-x-6 sm:p-6">
      <div className="flex items-start gap-3">
        <Cookie className="mt-1 shrink-0 text-[color:var(--terracotta)]" />
        <div className="text-sm sm:text-base">
          <p className="font-display text-lg font-bold">Vos choix sur les cookies</p>
          <p className="mt-1 text-[color:var(--muted-ink)]">
            Lis-Moi n'utilise que les cookies indispensables pour vous garder connecté. Aucun cookie publicitaire ni de mesure d'audience n'est déposé, et aucun ne le sera sans votre accord.{" "}
            <Link to="/confidentialite" data-testid="cookie-policy-link" className="font-bold underline">En savoir plus</Link>
          </p>
        </div>
      </div>
      <div className="mt-4 grid grid-cols-2 gap-3">
        <button data-testid="cookie-refuse-button" onClick={() => choose("refused")} className="btn-ghost w-full">Tout refuser</button>
        <button data-testid="cookie-accept-button" onClick={() => choose("accepted")} className="btn-ghost w-full">Tout accepter</button>
      </div>
    </div>
  );
}
